import { cn } from "@/components/common/utils";

interface Props {
  label: string;
  isSelected: boolean;
  isPending: boolean;
  onClick: () => void;
  className?: string;
}

export const FilterButton = ({
  label,
  isSelected,
  onClick,
  isPending,
  className,
}: Props) => {
  return (
    <button
      onClick={onClick}
      className={cn(
        "rounded-md px-3 py-2 text-sm font-medium transition-colors duration-200 ease-in-out",
        isSelected
          ? "bg-[#29333C] text-white"
          : "bg-gray-100 text-primary-blue",
        isPending && "opacity-70",
        className
      )}
    >
      {label}
    </button>
  );
};
